import { Button } from '@ais-ui/ui-core';
import { cn } from '@ais-ui/utils';
import { SettingItem } from './SettingsPage';
import { NavLink } from 'react-router-dom';

interface SidebarNavProps extends React.HTMLAttributes<HTMLElement> {
  items: {
    id: SettingItem;
    title: string;
    onClick: () => void;
  }[];
  activeItem: SettingItem;
}

export function SidebarNav({
  className,
  items,
  activeItem,
  ...props
}: SidebarNavProps) {
  return (
    <nav
      className={cn(
        'flex space-x-2 lg:flex-col lg:space-x-0 lg:space-y-1',
        className
      )}
      {...props}
    >
      {items.map((item) => (
        <Button
          id={item.id}
          key={item.id}
          variant={activeItem === item.id ? 'secondary' : 'ghost'}
          className="w-56 justify-start"
          onClick={() => item.onClick()}
        >
          {item.title}
        </Button>
      ))}
    </nav>
  );
}
